module.exports = __webpack_public_path__ + "static/img/bank@2x.15bece4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbConsociation/bank@2x.png
// module id = i9ay
// module chunks = 70